module.exports = __webpack_public_path__ + "img/elevator-body.bc5b8bda.png";